import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Wrapper from "../../components/Wrapper";
import Header from "../../components/Header";
import TopBar from "../../components/TopBar";
import ErrorImage from "../../assets/motor/error_buy.png";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {};

class ErrorBuy extends Component {
  backButton = () => {
    const {
      history: { push }
    } = this.props;
    push("/");
  };

  render() {
    return (
      <Wrapper>
        <div style={{ margin: "16px", marginTop: '66px' }}>
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img alt="error_image" src={ErrorImage} style={{ width: "120px", height: "120px" }} />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "18px",
              color: "#0e162c"
            }}
          >
            สมัครประกันไม่สำเร็จ
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontSize: "16px",
              color: "#999999"
            }}
          >
            ขออภัยในความไม่สะดวก กรุณาติดต่อบริษัทกรุงเทพประกันภัย 0 2285 8888
          </p>
          <br />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <button
              style={{
                ...fontDefault,
                color: "#118df5",
                padding: "10px 25px",
                border: "1px solid #118df5",
                borderRadius: "20px",
                backgroundColor: "white"
              }}
              onClick={this.backButton}
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          >
          </TopBar>
        </Header>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorBuy));
